var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabProductSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0133333 7.83325C3.88 5.81992 7.74667 3.83325 11.6133 1.83325C13.04 2.88659 14.4667 3.95325 15.8933 5.01992C17.3867 3.95325 18.8667 2.89992 20.3333 1.83325C24.2267 3.84659 28.1067 5.88658 32 7.91325C30.6667 9.13992 29.3467 10.3799 28.0133 11.6066C29.3333 13.1399 30.68 14.6733 32 16.2066C28.3867 18.1933 24.7867 20.2066 21.1733 22.1933L21.1067 22.1799C19.6267 20.6199 18.1467 19.0599 16.68 17.4999C19.9733 15.7533 23.2533 13.9933 26.5467 12.2333C23.0533 10.2466 19.52 8.35325 16.0133 6.39325C12.48 8.32658 8.96 10.2599 5.44 12.2066C8.74667 13.9666 12.0533 15.7133 15.3467 17.4733C13.88 19.0866 12.4 20.7133 10.9333 22.3266C7.29333 20.2199 3.64 18.1133 0 16.0066V15.8466L0.04 15.9799C1.33333 14.4999 2.68 13.0733 4 11.6066C2.66667 10.3533 1.33333 9.09992 0 7.83325V7.69992L0.0133333 7.83325Z",
    fill: "#777D7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6793 19.4333C18.0793 20.9133 19.4793 22.4067 20.8927 23.8867C23.2527 22.5667 25.626 21.26 27.9993 19.94C27.9993 21.6734 28.0127 23.4067 27.986 25.14C24.2127 27.1267 20.4393 29.1667 16.666 31.1667C16.6793 27.26 16.6527 23.34 16.6793 19.4333Z",
    fill: "#777D7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2006 24.0067C12.5739 22.5133 13.9339 20.98 15.3339 19.5C15.3472 23.38 15.3339 27.26 15.3472 31.14C11.5472 29.18 7.80057 27.1133 4.01391 25.1267C4.00057 23.3667 4.00057 21.6067 4.01391 19.8467C6.40057 21.2467 8.80057 22.62 11.2006 24.0067Z",
    fill: "#777D7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabProductSale);
export default __webpack_public_path__ + "static/media/tab-product-sale.8e284d15b2f38181c66680fdd895431b.svg";
export { ForwardRef as ReactComponent };